import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { Divider, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  collection as firebaseCollection,
  orderBy,
  query,
  onSnapshot,
  limit,
} from "firebase/firestore";
import { db } from "../../firebase";
import { DEFAULT_AVATAR_URL } from "../../common/enum";

const MenuListMessages = () => {
  const [entities, setEntites] = React.useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  React.useEffect(() => {
    const getData = () => {
      const q = query(
        firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
        orderBy("updatedDate", "desc"),
        limit(3)
      );
      const unsub = onSnapshot(q, (snap) => {
        const arr = [];
        snap.forEach((doc) => {
          arr.push(doc.data());
        });
        setEntites([...arr]);
      });
      return () => {
        unsub();
      };
    };
    profile?.userId && getData();
  }, []);

const [profileImages, setProfileImages] = useState(new Map());
const dispatch = useDispatch();

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of entities) {
      const id = item?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
            newMap.set(item.entityId, imageUrl);
        }else{
            newMap.set(item.entityId, DEFAULT_AVATAR_URL);
        }
      
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [entities, dispatch]);



  return (
    <Box dense sx={{ width: "100%" }}>
      {entities.length > 0 &&
        entities.map((value) => {
          const labelId = `checkbox-list-secondary-label-${value.entityId}`;

          return (
            <React.Fragment key={value.entityId}>
              <Box sx={{ p: 0, my: 1 , display:"flex"}}>
                <ListItemAvatar>
                  <Avatar
                    alt={value.entityName}
                    src={
                      value.profilePicture === "string" ||
                      value.profilePicture === null
                        ? DEFAULT_AVATAR_URL
                        : profileImages.get(value.entityId)

                    }
                    sx={{
                      backgroundColor: "green",
                      "& img": {
                        height:
                          value.profilePicture === "string" ||
                          value.profilePicture === null
                            ? "100%"
                            : "100%",
                        width:
                          value.profilePicture === "string" ||
                          value.profilePicture === null
                            ? "100%"
                            : "100%",
                      },
                    }}
                  />
                </ListItemAvatar>
                <ListItemText
                  id={labelId}
                  primary={
                    <Typography variant="body2" fontWeight={600} className="LabelNomeResize">
                      
                      {value.entityName}
                    </Typography>
                  }
                />
                <Chip
                  label={`${new Date(
                    value.collectionCreatedDate
                  ).getFullYear()}${value.collectionId}`}
                  sx={{
                    backgroundColor: "#E4F2E8",
                    color: "#1B727E",
                    mx: 1,
                    "& .MuiChip-label": {
                      fontWeight: 600,
                      fontFamily: "Poppins",
                    },
                  }}
                />
                <ListItemText
                  id={labelId}
                  secondary={`${value.updatedDate
                    .toDate()
                    .toLocaleTimeString("pt", {
                      hour: "numeric",
                      minute: "numeric",
                    })}m`}
                />
              </Box>
              <Divider sx={{ borderColor: "rgba(145, 158, 171, 0.69)" }} />
            </React.Fragment>
          );
        })}
    </Box>
  );
};

export default MenuListMessages;
